module.exports = __webpack_public_path__ + "static/media/GTCJ.5fb18cea.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/GTCJ.jpg
// module id = 1346
// module chunks = 1